import React from "react";

import "./index.css";

export const CustomLoaderFullScreen = ({ size = 50 }) => {
  return (
    <div
      style={{
        position: "absolute",
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(116, 117, 117, 0.5)",
        zIndex: 99999,
      }}
    >
      <div
        className="spinner-full"
        style={{
          borderTopColor: "#8483B4",
          height: size,
          width: size,
        }}
      />
    </div>
  );
};
